// composables/sendFile.js
import { ref} from "vue";

export function sendFile(uploadUrl, auth_code="", extraHeaders = {}) {
  const isUploading = ref(false);
  const progress = ref(0);
  const error = ref(null);
  const response = ref(null);

  /**
   * Upload files
   * @param {File|File[]} files - Single file or array of files
   * @param {Object} extraData - Optional additional form fields
   */
  const send = async (files, extraData = {}) => {
    isUploading.value = true;
    progress.value = 0;
    error.value = null;
    response.value = null;

    try {
      const formData = new FormData();
      formData.append("author_code", auth_code);

      if (Array.isArray(files)) {
        files.forEach((file, idx) => {
          formData.append(`file_${idx}`, file);
        });
      } else {
        formData.append("file", files);
      }

      // Add extra fields if any
      Object.entries(extraData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      // Use XMLHttpRequest to track progress
      const xhr = new XMLHttpRequest();

      const uploadPromise = new Promise((resolve, reject) => {
        xhr.upload.addEventListener("progress", (event) => {
          if (event.lengthComputable) {
            progress.value = Math.round((event.loaded / event.total) * 100);
          }
        });

        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                try {
                response.value = JSON.parse(xhr.responseText);
                } catch (e) {
                error.value = "Server did not return valid JSON.";
                response.value = null;
                reject(error.value);
                return;
                }
                resolve(response.value);
            } else {
                error.value = xhr.statusText || "Upload failed";
                reject(error.value);
            }
        };

        xhr.onerror = () => {
          error.value = "Network error";
          reject(error.value);
        };
      });

      xhr.open("POST", uploadUrl, true);
      xhr.withCredentials = false; // allow CORS without credentials
      Object.entries(extraHeaders).forEach(([key, val]) => {
        xhr.setRequestHeader(key, val);
      });

      xhr.send(formData);

      await uploadPromise;
    } catch (err) {
      error.value = err.message || "Unknown error";
    } finally {
      isUploading.value = false;
    }
  };

  return {
    isUploading,
    progress,
    error,
    response,
    send,
  };
}
